var exports = {
  "k": "xe564cbfb--37aba3--container",
};

module.exports = exports;
